// EMİR #78 — DEĞER-SONRASI push-izni soft-prompt'u ("İlk Kıvılcım").
//
// Push-izni artık onboarding'de İSTENMİYOR (WelcomeWizard'dan çıkarıldı). Yerine:
// kullanıcı DEĞER gördükten sonra — ilk 5★'ını verince (mlv3:clip-rated, value>=4)
// VEYA ilk paylaşımını yapınca (mlv3:clip-shared) — tek-seferlik nazik bir kart
// çıkar. localStorage ile en fazla 2 kez (reddedene tekrar-tekrar sorma).
import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import usePushPermission from "../hooks/usePushPermission";
import "./FirstSparkPushPrompt.css";
import { IkonKoprusu } from "../icon-system/runtime/IkonKoprusu";

const KEY_DONE = "mlsa.firstSpark.push.done";     // "1" → bir daha gösterme
const KEY_SHOWN = "mlsa.firstSpark.push.shown";   // gösterim sayısı (dismiss ile artar)
const MAX_SHOWN = 2;

function isDone(): boolean {
  try { return localStorage.getItem(KEY_DONE) === "1"; } catch { return false; }
}
function setDone(): void { try { localStorage.setItem(KEY_DONE, "1"); } catch { /* no-op */ } }
function shownCount(): number { try { return Number(localStorage.getItem(KEY_SHOWN) || 0) || 0; } catch { return 0; } }
function bumpShown(): void { try { localStorage.setItem(KEY_SHOWN, String(shownCount() + 1)); } catch { /* no-op */ } }

const FirstSparkPushPrompt: React.FC = () => {
  const { t } = useTranslation(["onboarding"]);
  const push = usePushPermission();
  const [visible, setVisible] = useState(false);

  const maybeShow = useCallback(() => {
    if (isDone()) return;
    if (shownCount() >= MAX_SHOWN) { setDone(); return; }
    // Yalnız izin gerçekten istenebilirse (destekli + default + snooze bitmiş + signed-in).
    if (!push.shouldPrompt) return;
    setVisible((v) => (v ? v : true));
  }, [push.shouldPrompt]);

  useEffect(() => {
    // Değer-anı olayları: ilk 5★ (value>=4) veya ilk paylaşım.
    const onRated = (e: any) => { if (Number(e?.detail?.value) >= 4) maybeShow(); };
    const onShared = () => maybeShow();
    window.addEventListener("mlv3:clip-rated", onRated as any);
    window.addEventListener("mlv3:clip-shared", onShared as any);
    return () => {
      window.removeEventListener("mlv3:clip-rated", onRated as any);
      window.removeEventListener("mlv3:clip-shared", onShared as any);
    };
  }, [maybeShow]);

  const accept = useCallback(async () => {
    setVisible(false);
    setDone(); // istendi (kabul/ret fark etmez) → bir daha sorma
    try { await push.askPermission(); } catch { /* no-op */ }
  }, [push]);

  const later = useCallback(() => {
    setVisible(false);
    bumpShown();
    try { push.dismiss(); } catch { /* no-op */ }
    if (shownCount() >= MAX_SHOWN) setDone();
  }, [push]);

  if (!visible) return null;

  return (
    <div className="fsp-wrap" role="dialog" aria-live="polite" aria-label="Bildirim izni">
      {/* EMİR #84 whitelist — data-eye-allow-overlap GEREKÇE: değer-anı push
          soft-prompt'u BİLİNÇLİ yüzen karttır; feed/nav üzerine geçici binmesi
          tasarımın kendisi (kapatılınca kalkar). GÖZ overlap-dedektörü istisnası. */}
      <div className="fsp-card" data-eye-allow-overlap="true">
        <div className="fsp-icon" aria-hidden="true"><IkonKoprusu aile="notification.bell" eski="🔔" /></div>
        <div className="fsp-text">
          <div className="fsp-title">{t("onboarding:spark.title")}</div>
          <div className="fsp-sub">{t("onboarding:spark.sub")}</div>
        </div>
        <div className="fsp-actions">
          <button type="button" className="fsp-btn fsp-btn--ghost pressable" onClick={later}>{t("onboarding:spark.later")}</button>
          <button type="button" className="fsp-btn fsp-btn--primary pressable" onClick={accept} disabled={push.pending}>
            {push.pending ? "…" : t("onboarding:spark.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FirstSparkPushPrompt;
